/**
 *
 * @param {Response} response
 */
export const getJsonFetchOption = async (_response) => {
  try {
    const response = await _response;
    if (response.ok) {
      try {
        return {
          data: await response.json(),
        };
      } catch (error) {
        return {
          error,
        };
      }
    } else {
      return {
        error: response.statusText,
      };
    }
  } catch (error) {
    return { error };
  }
};
